import React from 'react';
import RatingInput from '../components/RatingInput';

function RatingPage({handleRating}) {
  
  return (
    <div className='w-screen h-screen content-center justify-items-center'>
        <img className='absolute top-0 right-10 md:w-1/4 w-1/2 h-auto' src={process.env.PUBLIC_URL + '/logo.png'} />
        <h1 className='text-4xl font-bold my-10'>How satisfied are you with today's visit?</h1>
        <div className='w-full scale-[.50] md:scale-100 origin-top'>
          <RatingInput handleRating={handleRating} />
        </div>
    </div>
  );
}

export default RatingPage;